<template>
  <button :class="classes" @click="handleClick" :disabled="saving">
    <span class="spinner-border spinner-border-sm" v-if="saving"></span>
    <span v-else>
      <icon type="check-circle" class="mr-2" />
      <slot>Save</slot>
    </span>
    <span v-if="saving && savingText" class="pl-2">{{ savingText }}</span>
  </button>
</template>
<script>
export default {
  name: "Save",
  props: {
    saving: Boolean,
    savingText: String,
    type: {
      type: String,
      default: "button",
    },
    classes: {
      type: String,
      default: "btn btn-success",
    },
  },
  methods: {
    handleClick: function () {
      this.$emit("click");
    },
  },
};
</script>
